// extracted by mini-css-extract-plugin
export default {"idwTableContainer":"idw-table-container__idw-table-container__uCPpx"};